module.exports = __webpack_public_path__ + "static/multi-37ef00a0906dd366edd5d08c3de1a720.gif";